const CloseIcon = ({ className, size = 6 }: { className?: string; size?: number }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={size}
            height={size}
            viewBox="0 0 6 6"
            fill="none"
            className={className}
        >
            <path d="M5.5 0.5L0.5 5.5M0.5 0.5L5.5 5.5" stroke="#52525C" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    );
};

export default CloseIcon;
